import { useEffect, useRef } from 'react';
import { ButtonsBar, Modal } from '../../components/Modal';
import { SearchInput } from '../../components/SearchInput';
import { Dropdown } from '../../components/Dropdown';
import { ButtonOutline, ButtonPrimary } from '../../components/Button';
import { useTranslations } from 'next-intl';

export function LocationModal({
  onClose,
  onSubmit,
  search,
  onSearchChange,
  items,
  loading,
  isItemsEmpty,
  onSelect,
}) {
  const t = useTranslations();
  const input = useRef(null);
  useEffect(() => {
    input.current.focus();
  }, []);
  return (
    <Modal>
      <div className="flex flex-col flex-1">
        <SearchInput
          ref={input}
          className="!mx-4 !mb-4 !mt-5 max-sm:!mt-4 max-sm:!mb-0 sm:!mx-10"
          onChange={onSearchChange}
          placeholder={t('where')}
          label={t('search-location')}
          value={search}
        />
        <div className="relative overflow-x-hidden overflow-y-auto flex flex-1 !mx-4 !mb-4 !mt-5 max-sm:!mt-4 max-sm:!mb-0 sm:!mx-10">
          <Dropdown
            className="absolute top-0 left-0"
            value={search}
            items={items}
            loading={loading}
            isEmpty={isItemsEmpty}
            isAbsolute
            onSelect={onSelect}
          />
        </div>
      </div>
      <ButtonsBar>
        <ButtonOutline onClick={onClose}>{t('action-close')}</ButtonOutline>
        <ButtonPrimary onClick={onSubmit}>{t('add-dates')}</ButtonPrimary>
      </ButtonsBar>
    </Modal>
  );
}
